import { render, staticRenderFns } from "./RolesTab.vue?vue&type=template&id=7068f038"
import script from "./RolesTab.vue?vue&type=script&lang=js"
export * from "./RolesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports